import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthType, UserInfoResponse } from "@/api/types";
import { getToken } from "@/lib/auth";

const STORAGE_KEY = "forttrade-user-session";

interface UserState {
  /** 邮箱登录时展示用 */
  email: string | null;
  /** email=邮箱托管 · wallet=Web3 钱包（来自 GetUserInfo，便于分支交互） */
  authType: AuthType | null;
  userInfo: UserInfoResponse | null;
  setAuthSession: (params: {
    userInfo: UserInfoResponse | null;
    email?: string | null;
  }) => void;
  setUserInfo: (userInfo: UserInfoResponse | null) => void;
  clearUserInfo: () => void;
}

/** 用户信息全局状态（email / authType / userInfo 持久化到 localStorage） */
export const useUserStore = create<UserState>()(
  persist(
    set => ({
      email: null,
      authType: null,
      userInfo: null,

      setAuthSession: ({ userInfo, email }) =>
        set(state => ({
          userInfo,
          email: email !== undefined ? email : state.email,
          authType: userInfo?.authType ?? null,
        })),

      setUserInfo: userInfo =>
        set({
          userInfo,
          authType: userInfo?.authType ?? null,
        }),

      clearUserInfo: () => set({ email: null, authType: null, userInfo: null }),
    }),
    {
      name: STORAGE_KEY,
      partialize: state => ({
        email: state.email,
        authType: state.authType,
        userInfo: state.userInfo,
      }),
      onRehydrateStorage: () => state => {
        if (!getToken()) {
          state?.clearUserInfo();
        }
      },
    }
  )
);
